import { cn } from '@/lib/utils';

/** The card mark: a card outline with the beacon dot. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={cn('size-6 shrink-0', className)} aria-hidden="true">
      <rect x="2.25" y="5.75" width="19.5" height="12.5" rx="2.75" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="16" cy="10.25" r="2.1" className="fill-signal" />
    </svg>
  );
}

/** Mark + lowercase wordmark. Inherits text color, so it works on light, dark, and night surfaces. */
export function Wordmark({ className, size = 'md' }: { className?: string; size?: 'md' | 'lg' }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark className={size === 'lg' ? 'size-7' : undefined} />
      <span
        className={cn(
          'font-semibold leading-none tracking-[-0.035em]',
          size === 'lg' ? 'text-[22px]' : 'text-[17px]',
        )}
      >
        latisent
      </span>
      <span className="sr-only">Latisent</span>
    </span>
  );
}
